export const WS_URL = 'wss://drip7.xyz:8080'
export const WS_MAX_SIZE = 1048576
export const HOST = 'https://drip7.xyz'
export const SENTRY_DSN =  "https://7209d48aa10568b6a135922b6985d323@o4506077940350976.ingest.sentry.io/4506079526191104"
export const SENTRY_ENV = "staging"
export const STRIPE_PK = "pk_test_51IgXVuCEF79w8UWnTmf7mJdnGYORgwSCDwh5jLtpzKmiKqOKd7v1TS4E4PFDfMpDB6CZO3pd28oyXRbs5ysj0WMz00NUsQba8d"
export const STRIPE_URL = "https://drip7.xyz/onboard_complete"

